import {useRoute} from '@react-navigation/native';
import React from 'react';
import {useQuery} from 'react-query';
import {getById} from '../../api';
import {View} from 'react-native';
import {Product} from '../../types';
import {ProductParams} from '../../types/nav';
import {Button, List} from 'react-native-paper';
import {ShopProductParams} from './paramseditor';

export function ShopProduct() {
  const route = useRoute();
  const {productId} = route.params as ProductParams;
  const queryKey = 'product_' + productId;
  const productQuery = useQuery(
    queryKey,
    async () => await getById(productId),
  );
  const product = productQuery.data as Product;
  return (
    <View style={{width: '100%', height: '100%'}}>
      <List.Section>
        <ShopProductParams
          product={product}
          productKey="title"
          title={'Name: '}
        />
        <ShopProductParams
          product={product}
          productKey="description"
          title={'Description: '}
        />
        <ShopProductParams
          product={product}
          productKey="preview"
          title={'Preview: '}
          isFileSelector={true}
        />
        <ShopProductParams
          product={product}
          productKey="price"
          title={'Price: '}
        />
        <ShopProductParams
          product={product}
          productKey="status"
          title={'Status: '}
          staticParam={true}
        />
        <List.Item
          title={() => (
            <Button mode={'contained'}>{'Publish'}</Button>
          )}
        />
      </List.Section>
    </View>
  );
}
